import { NextPageContext } from 'next';

import { MetaHead, getMetadataForSEO } from 'common/metaHead';
import { SearchParamsContextProvider } from 'contexts/searchParams';
import Main from 'main/index';

interface IProps {
  description?: string;
  image?: string;
  title?: string;
}

export default function FlightMain({ description, image, title }: IProps) {
  return (
    <>
      <MetaHead description={description} image={image} title={title} />
      <SearchParamsContextProvider>
        <Main />
      </SearchParamsContextProvider>
    </>
  );
}

FlightMain.getInitialProps = async ({ query }: NextPageContext) => {
  const { description, image, title } = await getMetadataForSEO(query);
  return { description, image, title };
};
